import { useState, useRef, useEffect } from "react";

type Props = {
  onSelectModal: (modal: "updates" | "tester" | "build") => void;
};

export function StayConnectedDropdown({ onSelectModal }: Props) {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleClose = () => setOpen(false);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        handleClose();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>
      <span
        onClick={() => setOpen(!open)}
        className="cursor-pointer text-sm font-medium hover:underline opacity-75"
      >
        Keep me in the loop
      </span>

      {open && (
        <div className="absolute right-0 mt-2 w-64 rounded-md shadow-xl bg-white border border-gray-200 z-20">
          <div className="py-1">
            <button
              onClick={() => {
                onSelectModal("updates");
                handleClose();
              }}
              className="block w-full px-4 py-2 text-left text-sm text-gray-800 hover:bg-gray-100"
            >
              Get Updates
            </button>
            <button
              onClick={() => {
                onSelectModal("tester");
                handleClose();
              }}
              className="block w-full px-4 py-2 text-left text-sm text-gray-800 hover:bg-gray-100"
            >
              Join as a Tester
            </button>
            <button
              onClick={() => {
                onSelectModal("build");
                handleClose();
              }}
              className="block w-full px-4 py-2 text-left text-sm text-gray-800 hover:bg-gray-100"
            >
              Help Build MiValta
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
